import { Head, Link } from "@inertiajs/react"
import { Coffee } from "lucide-react"

import AppLayout from "@/layouts/app-layout"
import { samplesPath } from "@/routes"
import type { BreadcrumbItem } from "@/types"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Muestras",
    href: samplesPath(),
  },
  {
    title: "Seleccionar Tipo",
    href: "/samples/select-type",
  },
]

const productTypes = [
  {
    type: "coffee",
    title: "Café",
    description: "Crear una muestra de café para catación",
    icon: Coffee,
    color: "bg-amber-100 dark:bg-amber-900",
    iconColor: "text-amber-600 dark:text-amber-300",
    hoverColor: "hover:border-amber-600",
  },
]

export default function SelectType() {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Seleccionar Tipo de Muestra" />

      <div className="flex h-full flex-1 flex-col gap-6 p-6">
        {/* Header */}
        <div>
          <h1 className="text-3xl font-bold tracking-tight">
            Crear Nueva Muestra
          </h1>
          <p className="text-muted-foreground">
            Selecciona el tipo de producto que deseas registrar
          </p>
        </div>

        {/* Product Type Cards */}
        <div className="grid max-w-4xl gap-6 md:grid-cols-2 lg:grid-cols-3">
          {productTypes.map((product) => {
            const Icon = product.icon
            return (
              <Link
                key={product.type}
                href={`/samples/select-format?product_type=${product.type}`}
              >
                <Card
                  className={`cursor-pointer border-2 transition-all hover:shadow-lg ${product.hoverColor}`}
                >
                  <CardHeader>
                    <div
                      className={`mb-4 rounded-full ${product.color} w-fit p-4`}
                    >
                      <Icon className={`h-12 w-12 ${product.iconColor}`} />
                    </div>
                    <CardTitle className="text-2xl">{product.title}</CardTitle>
                    <CardDescription className="text-base">
                      {product.description}
                    </CardDescription>
                  </CardHeader>
                </Card>
              </Link>
            )
          })}
        </div>

        {/* Info Section */}
        <Card className="max-w-4xl">
          <CardContent className="pt-6">
            <h3 className="mb-2 font-semibold">
              ¿Qué tipo de muestra debo seleccionar?
            </h3>
            <ul className="text-muted-foreground space-y-2 text-sm">
              <li>
                <strong>Café:</strong> Para granos de café verde o tostado que
                serán evaluados mediante catación SCA (Arábica, Robusta, CVA)
              </li>
            </ul>
          </CardContent>
        </Card>
      </div>
    </AppLayout>
  )
}
